import { PASSENGER_TYPES } from 'tickets/utils/constants.js'

export const createPassenger = (type, age, travelCard) => {
  return { type, age, travelCard }
}

export const cleanUpPassenger = (passenger) => {
  const isYouth = passenger.type === PASSENGER_TYPES.youth
  const isSenior = passenger.type === PASSENGER_TYPES.senior
  const noAge = passenger.age == null
  if ((isYouth || isSenior) && noAge) {
    return createPassenger(PASSENGER_TYPES.adult, null, passenger.travelCard)
  }
  return passenger
}
